import { baseApi } from '@/lib/api/baseApi';

export type CreateContactRequestBody = {
  name: string;
  email: string;
  phone: string;
  subject: string;
  message: string;
  turnstileToken?: string;
};

export const contactApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    /** İletişim formu. Oturum gerektirmez; ziyaretçi de gönderebilir. */
    createContactRequest: builder.mutation<string, CreateContactRequestBody>({
      query: (body) => ({
        url: 'contact-requests/add',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useCreateContactRequestMutation } = contactApi;
